module.exports = __webpack_public_path__ + "static/harvest-e9f56fc2cf43177998f7d4d6a85f8025.png";